import { isEmbedded } from "@emkit/adapter-emdash/bridge";
import { useState } from "react";
import { MediaGalleryPicker } from "./MediaGalleryPicker.js";

interface MediaFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  /** MIME-type filter for the file picker. Defaults to images. */
  accept?: string;
  placeholder?: string;
}

/**
 * URL input with a "Browse…" button that opens the media gallery (when the
 * editor is embedded in EmDash). The gallery handles both browsing existing
 * uploads and uploading new ones — clicking a tile sets the field's URL.
 *
 * Standalone mode hides the gallery button — users paste URLs by hand.
 */
export function MediaField({
  label,
  value,
  onChange,
  accept = "image/*",
  placeholder,
}: MediaFieldProps) {
  const [pickerOpen, setPickerOpen] = useState(false);
  const embedded = isEmbedded();

  return (
    <div className="emke-inspector-field">
      <label>{label}</label>
      <div style={{ display: "flex", gap: 6 }}>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          style={{ flex: 1, minWidth: 0 }}
        />
        {embedded && (
          <button
            type="button"
            className="emke-btn"
            onClick={() => setPickerOpen(true)}
            title="Open media gallery"
            style={{ padding: "4px 10px", fontSize: 11, whiteSpace: "nowrap" }}
          >
            Browse…
          </button>
        )}
      </div>
      {embedded && (
        <MediaGalleryPicker
          open={pickerOpen}
          accept={accept}
          onSelect={(url) => onChange(url)}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </div>
  );
}
